class URLValidator {
  static async isUrlValid(url) {
    console.log(`Validating URL>> ${url}`);
    try {
      const response = await fetch(url, { method: "HEAD" });
 
      if (response.redirected) return false;
      if (response.status === 404) return false;

      const isValid = response.ok;
      console.log(`URL ${url} is valid: ${isValid}`);
      return isValid;
    } catch (error) {
      console.error(`Error validating URL ${url}:`, error);
      return false;
    }
  }

  static async validateUrls(siblings) {
    console.log("Starting URL validation for siblings:", siblings);
    const validationPromises = siblings.map(async (sibling) => {
      const isValid = await this.isUrlValid(sibling.handle);
      return { sibling, isValid };
    });

    const results = await Promise.all(validationPromises);
    const validSiblings = results
      .filter((result) => result.isValid)
      .map((result) => result.sibling);
    console.log("Valid siblings:", validSiblings);
    return validSiblings;
  }

  static renderValidSiblings(validSiblings) {
    const container = document.getElementById("siblings-container");
    const activeSibling = document.querySelector(".sibling__active");
    const localeElement = document.querySelector("[data-current-locale]");
    const isUS = localeElement
      ? localeElement.getAttribute("data-current-locale") === "us"
      : false;

    // Clear the container before rendering
    container.innerHTML = "";

    if (validSiblings.length === 0) {
      console.log("No valid siblings found.");
      container.innerHTML = "";
      return;
    }

    container.appendChild(activeSibling);

    validSiblings.forEach((sibling) => {
      const link = document.createElement("a");
      // Get current locale and clean up path
      const pathParts = window.location.pathname.split("/").filter(Boolean);
      // const currentLocale = pathParts[0]?.length === 2 ? pathParts[0] : '';

      // Clean up handle by removing any trailing or leading slashes
      // const cleanHandle = sibling.handle.replace(/^\/+|\/+$/g, '');
      let currentLocale = "";
      if (isUS) {
        currentLocale = "en-us";
      } else {
        currentLocale = pathParts[0]?.length === 2 ? pathParts[0] : "";
      }

      const cleanHandle = sibling.handle.replace(/^\/+|\/+$/g, "");

      // Construct URL based on locale
      link.href = currentLocale
        ? `/${currentLocale}/products/${cleanHandle}`
        : `/products/${cleanHandle}`;

      console.log(`Rendered sibling: ${sibling.title} with URL: ${link.href}`);

      const img = document.createElement("img");
      img.src = sibling.images[0];
      img.alt = sibling.title;
      img.loading = "lazy";

      link.appendChild(img);
      container.appendChild(link);
      console.log(`Rendered sibling: ${sibling.title} with URL: ${link.href}`);
    });
  }

  static async init(siblings) {

    console.log("Initializing URL validation...");
    const validSiblings = await this.validateUrls(siblings);
    this.renderValidSiblings(validSiblings);
  }
}